/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlProfileFieldResponseAny } from './ControlProfileFieldResponseAny';
import {
    ControlProfileFieldResponseAnyFromJSON,
    ControlProfileFieldResponseAnyFromJSONTyped,
    ControlProfileFieldResponseAnyToJSON,
} from './ControlProfileFieldResponseAny';

/**
 * 
 * @export
 * @interface ControlGetProfileFieldsResponse
 */
export interface ControlGetProfileFieldsResponse {
    /**
     * 
     * @type {Array<ControlProfileFieldResponseAny>}
     * @memberof ControlGetProfileFieldsResponse
     */
    profile_fields: Array<ControlProfileFieldResponseAny>;
}

/**
 * Check if a given object implements the ControlGetProfileFieldsResponse interface.
 */
export function instanceOfControlGetProfileFieldsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "profile_fields" in value;

    return isInstance;
}

export function ControlGetProfileFieldsResponseFromJSON(json: any): ControlGetProfileFieldsResponse {
    return ControlGetProfileFieldsResponseFromJSONTyped(json, false);
}

export function ControlGetProfileFieldsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlGetProfileFieldsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profile_fields': ((json['profile_fields'] as Array<any>).map(ControlProfileFieldResponseAnyFromJSON)),
    };
}

export function ControlGetProfileFieldsResponseToJSON(value?: ControlGetProfileFieldsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profile_fields': ((value.profile_fields as Array<any>).map(ControlProfileFieldResponseAnyToJSON)),
    };
}

